(() => {
  if (window.welcomeOffersInitialized) return;
  window.welcomeOffersInitialized = true;
  const day = 24 * 60 * 60 * 1000;
  const cookieName = 'welcome_offer_dismissed_v1';
  const memory = new Map();

  const readStamp = key => {
    const values = [memory.get(key) || 0];
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try { values.push(Number(window[storageName].getItem(key)) || 0); } catch {}
    }
    try {
      const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(`${cookieName}=`));
      if (cookie) values.push(Number(cookie.slice(cookieName.length + 1)) || 0);
    } catch {}
    return Math.max(...values.filter(value => Number.isFinite(value) && value >= 0 && value <= Date.now() + day));
  };

  const writeStamp = key => {
    const stamp = Date.now();
    memory.set(key, stamp);
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try { window[storageName].setItem(key, String(stamp)); } catch {}
    }
    try { document.cookie = `${cookieName}=${stamp}; Max-Age=86400; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`; } catch {}
  };

  const safeDiscountLink = (link, input) => {
    const path = link.dataset.offerRedirect || '/';
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\') || /%(2f|5c)/i.test(path)) return false;
    const destination = new URL(path, location.origin);
    if (destination.origin !== location.origin || destination.hash || destination.search) return false;
    const coupon = new URL(`/discount/${encodeURIComponent(input.value)}`, location.origin);
    coupon.searchParams.set('redirect', destination.pathname);
    link.href = coupon.pathname + coupon.search;
    return true;
  };

  const initialize = scope => {
    const roots = scope.matches?.('[data-welcome-offer]') ? [scope] : scope.querySelectorAll('[data-welcome-offer]');
    roots.forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const input = root.querySelector('[data-offer-code]');
      const copy = root.querySelector('[data-offer-copy]');
      const status = root.querySelector('[data-offer-status]');
      const apply = root.querySelector('[data-offer-apply]');
      if (!input || !copy || !status) return;
      copy.addEventListener('click', async () => {
        copy.disabled = true;
        status.textContent = '';
        let copied = false;
        try {
          if (navigator.clipboard?.writeText && window.isSecureContext) {
            await navigator.clipboard.writeText(input.value);
            copied = true;
          }
        } catch {}
        if (!copied) {
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          try { copied = document.execCommand('copy'); } catch {}
        }
        status.textContent = copied ? root.dataset.copied : root.dataset.copyError;
        copy.disabled = false;
        if (copied) copy.focus();
      });
      if (apply && !safeDiscountLink(apply, input)) apply.remove();
      if (!root.matches('[data-welcome-popup]') || typeof root.showModal !== 'function') return;
      const key = root.dataset.storageKey || 'welcome-offers:dismissed';
      const suppressed = () => Date.now() - readStamp(key) < day;
      let timer;
      let previousFocus;
      const dismiss = () => {
        clearTimeout(timer);
        writeStamp(key);
        if (root.open) root.close();
      };
      const show = () => {
        if (!root.isConnected || suppressed()) return;
        if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) {
          timer = setTimeout(show, 1000);
          return;
        }
        previousFocus = document.activeElement;
        root.showModal();
        writeStamp(key);
      };
      root.querySelector('[data-offer-close]')?.addEventListener('click', dismiss);
      root.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
      root.addEventListener('close', () => {
        writeStamp(key);
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      });
      root.addEventListener('click', event => {
        if (event.target !== root) return;
        const box = root.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
      });
      apply?.addEventListener('click', () => writeStamp(key));
      window.addEventListener('storage', event => {
        if (event.key === key && suppressed()) {
          clearTimeout(timer);
          if (root.open) root.close();
        }
      });
      if (!document.body.classList.contains('template-cart') && !suppressed()) timer = setTimeout(show, Math.min(60, Math.max(1, Number(root.dataset.delay) || 8)) * 1000);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
